import React from 'react';

function Logout() {
  const handleLogout = () => {
    localStorage.removeItem('token'); // Menghapus token dari localStorage
    window.location.href = '/login'; // Arahkan pengguna ke halaman login
  };

  return (
    <button onClick={handleLogout}>Logout</button>
  );
}

export default Logout;
